import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../component/Sidebar";

const MainLayout = () => {
  return (
    <div className="d-flex">
      <Sidebar />
      <main className="" 
      // style={{ padding: "24px", marginTop: "68px", marginLeft: "235px" }}
      
      >
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout;
